/*
 * Pipeline Theme
 *
 * Use this file to add custom Javascript to Pipeline.  Keeping your custom
 * Javascript in this fill will make it easier to update Pipeline. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 *
 */

(async function () {
  // Below are example event listeners.  They listen for theme events that Pipeline
  // fires in order to make it easier for you to add customizations.

  // Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.

  const CURRENT_PARTNER_STORAGE_KEY = "CURRENT_PARTNER_STORAGE_KEY";
  const OVERRIDE_PARTNER_STORAGE_KEY = "OVERRIDE_PARTNER_STORAGE_KEY";
  const CURRENT_SHOP_AS_CUSTOMER_STORAGE_KEY =
    "CURRENT_SHOP_AS_CUSTOMER_STORAGE_KEY";

  const storedCustomerKey = sessionStorage.getItem(
    CURRENT_SHOP_AS_CUSTOMER_STORAGE_KEY
  );

  document.addEventListener("theme:cart:change", async function (event) {
    console.log("========= theme:cart:change =========");
    var cart = event.detail.cart;

    var startTime = performance.now();
    configureCustomCheckout(cart);
    var endTime = performance.now();
    console.log(
      "configureCustomCheckout took " + (endTime - startTime) + " milliseconds."
    );
  });

  function listenFetch() {
    var oriFetch = window.fetch;

    window.fetch = async (url, options) => {
      if (url.href?.includes("?sca_")) {
        return;
      }

      // fixes cart refresh issue for bogo gifts
      if (["/cart/update?sca_process_gifts"].includes(url)) {
        return;
      }

      return oriFetch(url, options).then(async (res) => {
        return res;
      });
    };
  }

  listenFetch();

  const kitCheck = (item) => { return item.product_type === "Kit" };

  async function configureCustomCheckout(cart) {
    console.log("========= congigureCustomCheckout start =========");
    const customCheckout = $("[data-checkout-custom]");
    const checkoutError = $("[data-checkout-error]");
    var disableCheckout = false;

    $(document.body).removeClass("loading-checkout");
    customCheckout.prop("disabled", true);

    let shopAsCustomer = null;

    if (storedCustomerKey) {
      shopAsCustomer = await fetch(
        `https://qaysz0xhkj.execute-api.us-west-2.amazonaws.com/Prod/partners?website=${storedCustomerKey}`
      )
        .then((response) => response.json())
        .then((response) => {
          return response;
        })
        .catch((err) => console.error(err));
    }

    if (cart && !shopAsCustomer) {
      const foundNonCommissionableItem = cart.items.find(
        (item) =>
          item.properties["_commissionable"] === "Non-Commissionable" &&
          kitCheck(item) === false
      );

      if (customCheckout.is("[data-invalid-standing]")) {
        disableCheckout = true;
      } else if (
        foundNonCommissionableItem &&
        !theme.is_partner &&
        foundNonCommissionableItem.product_type !== "Gift Card"
      ) {
        if (checkoutError) checkoutError.show();
        disableCheckout = true;
      } else {
        if (checkoutError) checkoutError.hide();
        disableCheckout = false;
      }
    }

    customCheckout.prop("disabled", disableCheckout);
    customCheckout.text(window.theme.strings.proceedToCheckout);

    customCheckout.unbind("click").bind("click", async (e) => {
      e.stopPropagation();
      e.preventDefault();
      console.log("========= customCheckout clicked =========");

      // Freedrop ////////////////////////////////////////////////////////////////////
      $(document.body).addClass("loading-checkout");
      const cart = await fetch(`/cart.js?t=${Date.now()}`).then((response) => response.json());
      const existingFreeItems = cart.items.filter((item) => !!item?.properties?.['_freedrop']);

      if (existingFreeItems.length) {
        const updates = existingFreeItems.reduce((acc, item) => {
          acc[item.key] = 0;
          return acc;
        }, {});
  
        await fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ updates }),
        });  
      }

      const freedrop = await fetch("https://qaysz0xhkj.execute-api.us-west-2.amazonaws.com/Prod/checkout/freedrop", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          ...(window?.customer?.id && { customerId: window.customer.id }),
          cart: cart,
        }),
      })
        .then((res) => res.json())
        .catch((e) => {
          console.log(e);
          return null;
        });

      console.log("freedrop", freedrop);
      if (freedrop && freedrop.items && freedrop.items.length) {
        const items = freedrop.items.map((item) => {
          const [id, dropId, quantity] = item.split(":");
          return {
            id: Number(id),
            quantity: quantity ?? 1,
            properties: {
              _freedrop: dropId,
            },
          };
        });

        await fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ items }),
        }).catch(async (e) => {
          console.log(e);
          for (const item of items) {
            await fetch("/cart/add.js", {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({ items: [item] }),
            });
          }
        });

        localStorage.setItem("FREEDROP", true);

        console.log("freedrop added to cart");
      }

      ///////////////////////////////////////////////////////////////////////////////

      $(document.body).addClass("loading-checkout");
      customCheckout.prop("disabled", true);

      let urlCustomerData = "";

      if (shopAsCustomer) {
        const extensionStorage = localStorage.getItem("extensionStorage");
        if (extensionStorage) localStorage.removeItem("extensionStorage");

        customerId = parseFloat(
          shopAsCustomer.id.replace("gid://shopify/Customer/", "")
        );
        // create checkout link customer data string
        urlCustomerData = `checkout[email]=${
          shopAsCustomer.email
        }&checkout[shipping_address][first_name]=${
          shopAsCustomer.defaultAddress.firstName
        }&checkout[shipping_address][last_name]=${
          shopAsCustomer.defaultAddress.lastName
        }&checkout[shipping_address][address1]=${encodeURIComponent(
          shopAsCustomer.defaultAddress.address1
        )}&checkout[shipping_address][address2]=${encodeURIComponent(
          shopAsCustomer.defaultAddress.address2 ?? ""
        )}&checkout[shipping_address][city]=${encodeURIComponent(
          shopAsCustomer.defaultAddress.city
        )}&checkout[shipping_address][country]=${encodeURIComponent(
          shopAsCustomer.defaultAddress.country
        )}&checkout[shipping_address][province]=${
          shopAsCustomer.defaultAddress.province
        }&checkout[shipping_address][zip]=${
          shopAsCustomer.defaultAddress.zip
        }&checkout[shipping_address][phone]=${
          shopAsCustomer.defaultAddress.phone
        }`;

        if (window.location.pathname !== "/cart") {
          return (window.location.href = "/cart");
        }
      }

      let bundles = [];
      let hasKit = false;
      let isGroupOrder = "false";
      let groupOrderID = "NONE";

      if (cart === undefined) {
        cart = await fetch("/cart.js").then((res) => res.json());
      }

      let totalCommissionable = 0;
      cart.items.forEach((item) => {
        if (item.product_type === "Kit") {
          hasKit = true;
        } else if (item.product_title.includes("Bundle")) {
          bundles.push(item);
        }
        if (item.properties && item.properties["Group Order Customer"]) {
          isGroupOrder = "true";
        }
        if (item.properties && item.properties["_GroupOrderCustomerID"]) {
          groupOrderCustomerID = item.properties["_GroupOrderCustomerID"];
          isGroupOrder = "false";
        }

        if(item.properties && item.properties["_commissionable"] === "Commissionable" || item.properties["_Category"] === "Commissionable" || item.properties["Category"] === "Commissionable" || item.properties["_set_type"] === "Kit Add-On") {
          totalCommissionable +=
            parseFloat(item.original_line_price) /
            100;
        }

      });

      // Handle group order checkout
      if (isGroupOrder === "true") {
        groupOrderID = window.customer.groupOrderID;
        const extensionStorage =
          window.localStorage.getItem("extensionStorage");
        if (extensionStorage) {
          const extensionStorageObj = JSON.parse(extensionStorage);
          const giftCardsKey = Object.keys(extensionStorageObj).find((key) =>
            key.includes("GROUP_ORDER_GIFT_CARD")
          );
          if (giftCardsKey) delete extensionStorageObj[giftCardsKey];
          window.localStorage.setItem(
            "extensionStorage",
            JSON.stringify(extensionStorageObj)
          );
        }

        try {
          await toggleTags(["group-order-in-progress"], []);
        } catch (error) {
          console.error(error);
        }
      } else {
        try {
          await toggleTags([], ["group-order-in-progress"]);
        } catch (error) {
          console.error(error);
        }
      }
      let sessionId = sessionStorage.getItem("CHECKOUT_CUSTOM_SESSION_ID");
      if (!sessionId) {
        sessionId = Date.now();
        sessionStorage.setItem("CHECKOUT_CUSTOM_SESSION_ID", sessionId);
      }

      // enrollment tax logic
      let enrollmentTax = false;


      // update commission_table values
      const commission_table = {};

      if(document.getElementById("_commissionables_original_subtotal") !== null) {
        commission_table.retail_value = {
          product_total: parseFloat(document.getElementById("_commissionables_original_subtotal").innerText.replace("$", "").replace(",", "")),
          commission: parseFloat(document.getElementById("_commissionable_discount").innerText.replace("%", "")),
          subtotal: parseFloat(document.getElementById("_commissionables_total").innerText.replace("$", "").replace(",", ""))
        }
        commission_table.non_retail_value = {
          product_total: parseFloat(document.getElementById("_non_commissionables_original_subtotal").innerText.replace("$", "").replace(",", "")),
          commission: parseFloat(document.getElementById("_non_commissionable_discount").innerText.replace("%", "")),
          subtotal: parseFloat(document.getElementById("_non_commissionables_total").innerText.replace("$", "").replace(",", ""))
        }
      }

      let curSite =
        sessionStorage.getItem(OVERRIDE_PARTNER_STORAGE_KEY) ??
        sessionStorage.getItem(CURRENT_PARTNER_STORAGE_KEY) ??
        null;
      console.log("curSite: " + curSite);

      // if cursite null, check if pws url exists and set as curSite
      if (curSite === null) {
        const url = new URL(window.location.href);
        const pwsUrl = url.searchParams.get("pws");
        if (pwsUrl) {
          curSite = pwsUrl;
        }
      }

      const brandAmbassadorId = await getPartnerIdBySite(curSite);
      console.log("brandAmbassadorId: " + brandAmbassadorId);

      const context = {
        curSite: curSite,
        customerId: window?.customer?.id ?? null,
        customerEmail: window?.customer?.email ?? null,
        groupOrderID: groupOrderID ?? null,
        isPartner: window?.customer?.isPartner ?? false,
        isQualifiedConsultant: window?.customer?.isQualifiedConsultant ?? false,
        sapConsultantSoldToId: window?.customer?.sapConsultantSoldToId ?? null,
        partyId: sessionStorage.getItem("URL_PARTY") ?? null,
        enrollmentTax: enrollmentTax ?? false,
        BrandAmbassadorId: brandAmbassadorId,
        shopAsSelected: shopAsCustomer ? true : false,
        taxExempt: window.customer ? window.customer.taxExempt === 'true' : false,
        //userType: window.customer ? window.customer.userType : null,
         userType: window.customer.userType ?? null,
        totalCommissionable: totalCommissionable,
        commissionTable: commission_table ? commission_table : null,
      };

      const checkoutUrl = new URL('/checkout', window.location.origin);
      const attributes = {
        GroupOrder: isGroupOrder,
        sessionID: sessionId,
        context: btoa(JSON.stringify(context))
      };

      if (sessionStorage.getItem("LOGIN_SOURCE")) {
        attributes["Order Impersonated By"] = sessionStorage.getItem("LOGIN_SOURCE");
      }

      // Add all attributes to URL params
      Object.entries(attributes).forEach(([key, value]) => {
        checkoutUrl.searchParams.append(`attributes[${key}]`, value);
      });

      if (window?.customer?.defaultAddress) {
        const address = window.customer.defaultAddress;
        checkoutUrl.searchParams.append("checkout[shipping_address][first_name]", address.first_name);
        checkoutUrl.searchParams.append("checkout[shipping_address][last_name]", address.last_name);
        checkoutUrl.searchParams.append("checkout[shipping_address][address1]", address.address1);
        checkoutUrl.searchParams.append("checkout[shipping_address][city]", address.city);
        checkoutUrl.searchParams.append("checkout[shipping_address][country]", address.country);
        checkoutUrl.searchParams.append("checkout[shipping_address][province]", address.province);
        checkoutUrl.searchParams.append("checkout[shipping_address][zip]", address.zip);
      }

      // clear checkout cache
      localStorage.removeItem("__ui");

        // logging for debugging
        await fetch(
          "https://qaysz0xhkj.execute-api.us-west-2.amazonaws.com/Prod/frontend/error-log",
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              cartToken: cart.token,
              cart: cart,
              context: context,
              url: checkoutUrl.toString(),
              cartUrl: window.location.href,
            }),
          }
        )
          .then((res) => res.json())
          .then((data) => {
            return data;
          })
          .catch((e) => console.log(e));

      window.location.href = checkoutUrl.toString();
    });

    console.log("========= congigureCustomCheckout end =========");
  }

  async function toggleTags(tagsToAdd, tagsToRemove) {
    let customerId = ShopifyAnalytics?.meta?.page?.customerId;
    if (!customerId) return;
    const url = `https://qaysz0xhkj.execute-api.us-west-2.amazonaws.com/Prod/partners/${customerId}/tags`;

    const body = {
      add: tagsToAdd,
      remove: tagsToRemove,
    };

    fetch(url, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    })
      .then(async (res) => {
        if (!res.ok) {
          return res.text().then((text) => {
            throw new Error(text);
          });
        } else {
          return res.json();
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }

  async function swapBundles(bundles, targetBundleTag) {
    return; // disable bundle swap
    const fetchVariantPromises = bundles.map(async (bundle) => {
      try {
        const response = await fetch(
          `https://qaysz0xhkj.execute-api.us-west-2.amazonaws.com/Prod/bundles/${
            bundle.product_id
          }/variants?tag=${encodeURIComponent(targetBundleTag)}`
        );
        const variants = await response.json();
        if (variants.length && bundle.id !== variants[0].id) {
          return {
            ori: bundle.id,
            new: variants[0].id,
            quantity: bundle.quantity,
            properties: bundle.properties,
          };
        }
      } catch (error) {
        console.error(
          `Error fetching variants for bundle with ID ${bundle.id}:`,
          error
        );
      }
      return null;
    });

    const variantResults = await Promise.allSettled(fetchVariantPromises);
    const changeSet = variantResults
      .filter((result) => result.status === "fulfilled" && result.value)
      .map((result) => result.value);

    if (changeSet.length) {
      const updates = {};
      changeSet.forEach((item) => {
        updates[item.ori] = 0;
      });

      await fetch("/cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", "X-Bundle-Swap": true },
        body: JSON.stringify({ updates }),
        redirect: "manual",
      });

      // new Promise(r => setTimeout(r, 200));

      const addItems = changeSet.map((item) => ({
        id: item.new,
        quantity: item.quantity,
        properties: item.properties,
      }));
      await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", "X-Bundle-Swap": true },
        body: JSON.stringify({ items: addItems.reverse() }),
        redirect: "manual",
      });

      // new Promise(r => setTimeout(r, 200));
    }
  }

  async function getPartnerIdBySite(storedCustomerKey) {
    let shopAsPartner = await fetch(
      `https://qaysz0xhkj.execute-api.us-west-2.amazonaws.com/Prod/partners?website=${storedCustomerKey}`,
      { method: "GET" }
    )
      .then((response) => response.json())
      .then((response) => {
        return response;
      })
      .catch((err) => console.error(err));

    if (shopAsPartner !== null) {
      return shopAsPartner.legacyResourceId;
    }
    return null;
  }

  async function checkoutChecks(cart, customerId) {
    if (customerId === undefined) {
      // check if shop_as customer and pull customerId from sessionStorage
      const CURRENT_SHOP_AS_CUSTOMER_STORAGE_KEY =
        "CURRENT_SHOP_AS_CUSTOMER_STORAGE_KEY";
      const storedCustomerKey = sessionStorage.getItem(
        CURRENT_SHOP_AS_CUSTOMER_STORAGE_KEY
      );
      if (!storedCustomerKey !== undefined) {
        customerId = await getPartnerIdBySite(storedCustomerKey);
      }
    }
    // console.log("customerId: " + customerId)

    if (customerId !== undefined && customerId !== null) {
      const options = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          customerId: customerId,
          cart: cart,
        }),
      };
      console.log(options);

      var checkoutCheckstartTime = performance.now();
      let { qualifiedCheck, tagCheck } = await fetch(
        "https://qaysz0xhkj.execute-api.us-west-2.amazonaws.com/Prod/partners/checkout-checks",
        options
      )
        .then((response) => {
          if (response.status !== 200) {
            return null;
          }
          return response.json();
        })
        .then((response) => {
          if (response === null) {
            return { qualifiedCheck: null, tagCheck: null };
          }
          return response;
        })
        .catch((err) => console.error(err));
      var checkoutCheckendTime = performance.now();

      console.log(
        `==== checkoutChecks took ${
          checkoutCheckendTime - checkoutCheckstartTime
        } milliseconds =====`
      );

      console.log("qualifiedCheck: " + JSON.stringify(qualifiedCheck));
      console.log("tagCheck: " + JSON.stringify(tagCheck));

      if (qualifiedCheck === null) {
        localStorage.setItem("qualifiedCheck", false);
        return false;
      }

      try {
        let cachedCheck =
          localStorage.getItem("qualifiedCheck") === "undefined"
            ? undefined
            : JSON.parse(localStorage.getItem("qualifiedCheck"));
        if (
          cachedCheck === undefined ||
          cachedCheck !== qualifiedCheck.qualified
        ) {
          localStorage.setItem("qualifiedCheck", qualifiedCheck.qualified);
        }
      } catch (error) {
        console.log(error);
      }

      return { qualifiedCheck, tagCheck };
    }
    return false;
  }

  function openCommissionWarningModal(modal, discountAmount, cartTotal) {
    // calculate progress
    let progressPercent = (cartTotal / discountAmount) * 100;
    let progressDifference = discountAmount - cartTotal;

    let modalTranslations = JSON.parse(commissionModalTranslations);

    let progressMessage = document.getElementById(
      "commission-adjt-warning__progress-message"
    );
    progressMessage.innerHTML = modalTranslations.commission_progress_message;
    progressMessage.innerHTML = progressMessage.innerHTML.replace(
      "{{progress_difference}}",
      progressDifference.toFixed(2)
    );

    let progressBar = document.getElementById(
      "commission-adjt-warning__progress-bar"
    );
    progressBar.setAttribute("value", Math.round(progressPercent));

    // set adjustment amount in message
    let warningMessage = document.getElementById(
      "commission-adjt-warning__message"
    );
    warningMessage.innerHTML = modalTranslations.commission_warning_body;
    warningMessage.innerHTML = warningMessage.innerHTML.replace(
      "{{adjustment_amount}}",
      discountAmount.toFixed(2)
    );

    const modalClose = modal.querySelectorAll("[data-micromodal-close]");
    modal.classList.add("is-open");
    modal.setAttribute("aria-hidden", "false");
    document.body.style.overflow = "hidden";

    modalClose.forEach((closeElement) =>
      closeElement.addEventListener("click", function () {
        modal.classList.remove("is-open");
        modal.setAttribute("aria-hidden", "true");
        document.body.style.overflow = "";
        $("#cart-page-checkout").prop("disabled", false);
      })
    );
  }

  window.onload = function () {
    const loginLogoutButtons = document.querySelectorAll(
      "#drawer-account [href*='logout'], #CustomerLoginFormDrawer button, #customer_login button"
    );

    loginLogoutButtons.length > 0 &&
      loginLogoutButtons.forEach((button) => {
        button.addEventListener("click", function () {
          localStorage.setItem("modalShown", "false");
          localStorage.setItem("PASSWORD_RESET_MODAL_SHOWN", false);
        });
      });

    function openModal(modal) {
      const showFormButton = modal.querySelector("[data-show-form-button]");
      const modalContent = modal.querySelector(".ssn-reminder");
      const modalSsnForm = modal.querySelector(".ssn-reminder-form");
      const modalClose = modal.querySelectorAll("[data-micromodal-close]");
      modal.classList.add("is-open");
      modal.setAttribute("aria-hidden", "false");
      document.body.style.overflow = "hidden";

      showFormButton.addEventListener("click", function () {
        modalContent.classList.add("hide");
        modalSsnForm.classList.remove("hide");
      });

      modalClose.forEach((closeElement) =>
        closeElement.addEventListener("click", function () {
          modal.classList.remove("is-open");
          modal.setAttribute("aria-hidden", "true");
          document.body.style.overflow = "";
        })
      );
    }

    if (localStorage.getItem("modalShown") !== "true") {
      const modal = document.getElementById("ssn-reminder");
      if (!modal) return;
      openModal(modal);
      localStorage.setItem("modalShown", "true");
    }
  };

  const initCart = await fetch("/cart.js").then((res) => res.json());
  if (window.FGSECOMAPP) {
    window.FGSECOMAPP.cart = initCart
  }

  // Password requirements logic
  // Existing DOM Elements
  const passwordField = document.getElementById("CreatePassword");
  const editPasswordField = document.getElementById("profile-password-input");
  const confirmPasswordField = document.getElementById(
    "profile-confirm-password-input"
  );
  const passwordResetField = document.getElementById("ResetPassword");
  const passwordResetConfirmField = document.getElementById(
    "PasswordConfirmation"
  );

  // New DOM Elements
  const customerPasswordField = document.getElementById("CustomerPassword");
  const customerPasswordConfirmField = document.getElementById(
    "CustomerPasswordConfirmation"
  );

  const requirements = document.querySelectorAll(".password-requirements li");

  const submitButton = document.querySelector("[data-password-submit]");
  const resetSubmitButton = document.querySelector(
    "[data-password-reset-submit]"
  );
  const activateSubmitButton = document.querySelector("[data-activate-submit]");

  const togglePasswordButton = document.getElementById("togglePassword");
  const togglePasswordConfirmButton = document.getElementById(
    "toggleConfirmPassword"
  );
  const togglePasswordResetButton = document.getElementById(
    "toggleResetPassword"
  );
  const togglePasswordResetConfirmButton = document.getElementById(
    "toggleConfirmResetPassword"
  );

  // New Toggle Buttons
  const toggleCustomerPasswordButton = document.getElementById(
    "toggleCustomerPassword"
  );
  const toggleCustomerPasswordConfirmButton = document.getElementById(
    "toggleCustomerPasswordConfirm"
  );

  const toggleActivatePasswordButton = document.getElementById(
    "toggleActivatePassword"
  );
  const toggleConfirmActivatePasswordButton = document.getElementById(
    "toggleConfirmActivatePassword"
  );

  let passwordVisible = false;

  // Function to toggle password visibility
  function toggleVisibility(button, field, iconId) {
    passwordVisible = !passwordVisible;
    const type = passwordVisible ? "text" : "password";
    if (field) field.setAttribute("type", type);
    document.getElementById(iconId).src = passwordVisible
      ? hidePasswordIconUrl
      : showPasswordIconUrl;
  }

  if (togglePasswordButton) {
    togglePasswordButton.addEventListener("click", function () {
      toggleVisibility(togglePasswordButton, passwordField, "toggleIcon");
      toggleVisibility(togglePasswordButton, editPasswordField, "toggleIcon");
    });
  }

  if (togglePasswordConfirmButton) {
    togglePasswordConfirmButton.addEventListener("click", function () {
      toggleVisibility(
        togglePasswordConfirmButton,
        confirmPasswordField,
        "toggleConfirmationIcon"
      );
    });
  }

  if (togglePasswordResetButton) {
    togglePasswordResetButton.addEventListener("click", function () {
      toggleVisibility(
        togglePasswordResetButton,
        passwordResetField,
        "toggleResetIcon"
      );
    });
  }

  if (togglePasswordResetConfirmButton) {
    togglePasswordResetConfirmButton.addEventListener("click", function () {
      toggleVisibility(
        togglePasswordResetConfirmButton,
        passwordResetConfirmField,
        "toggleConfirmationResetIcon"
      );
    });
  }

  // New Toggle Visibility Event Listeners
  if (toggleCustomerPasswordButton) {
    toggleCustomerPasswordButton.addEventListener("click", function () {
      toggleVisibility(
        toggleCustomerPasswordButton,
        customerPasswordField,
        "toggleCustomerPasswordIcon"
      );
    });
  }

  if (toggleCustomerPasswordConfirmButton) {
    toggleCustomerPasswordConfirmButton.addEventListener("click", function () {
      toggleVisibility(
        toggleCustomerPasswordConfirmButton,
        customerPasswordConfirmField,
        "toggleCustomerPasswordConfirmIcon"
      );
    });
  }

  if (toggleActivatePasswordButton) {
    toggleActivatePasswordButton.addEventListener("click", function () {
      toggleVisibility(
        toggleActivatePasswordButton,
        customerPasswordField,
        "toggleActivatePasswordIcon"
      );
    });
  }

  if (toggleConfirmActivatePasswordButton) {
    toggleConfirmActivatePasswordButton.addEventListener("click", function () {
      toggleVisibility(
        toggleConfirmActivatePasswordButton,
        customerPasswordConfirmField,
        "toggleActivationConfirmationIcon"
      );
    });
  }

  // Function to validate password
  function validatePassword(password) {
    const lengthRequirement = password.length >= 8 && password.length <= 20;
    const uppercaseRequirement = /[A-Z]/.test(password);
    const lowercaseRequirement = /[a-z]/.test(password);
    const numberRequirement = /\d/.test(password);
    const specialCharRequirement = /[!@#$%^&*]/.test(password);

    const requirementsMet =
      lengthRequirement &&
      uppercaseRequirement &&
      lowercaseRequirement &&
      numberRequirement &&
      specialCharRequirement;

    updateRequirementStatus(lengthRequirement, requirements[0]);
    updateRequirementStatus(uppercaseRequirement, requirements[1]);
    updateRequirementStatus(lowercaseRequirement, requirements[2]);
    updateRequirementStatus(numberRequirement, requirements[3]);
    updateRequirementStatus(specialCharRequirement, requirements[4]);

    return requirementsMet;
  }

  // Function to update requirement status
  function updateRequirementStatus(isMet, requirementElement) {
    if (isMet) {
      requirementElement.classList.add("met");
    } else {
      requirementElement.classList.remove("met");
    }
  }

  // Function to handle input events
  function handleInputEvent(
    event,
    passwordField,
    confirmPasswordField,
    submitButton
  ) {
    const password = passwordField.value;
    const confirmPassword = confirmPasswordField.value;
    const requirementsMet = validatePassword(password);

    const warningMessage = document.getElementById("password-warning");

    if (confirmPassword === password && requirementsMet) {
      submitButton.disabled = false;
      warningMessage.style.display = "none";
    } else {
      submitButton.disabled = true;
      if (confirmPassword !== password) {
        warningMessage.style.display = "block";
      } else {
        warningMessage.style.display = "none";
      }
    }
  }

  // Add event listeners to password fields
  if (editPasswordField && confirmPasswordField) {
    editPasswordField.addEventListener("input", function (event) {
      handleInputEvent(
        event,
        editPasswordField,
        confirmPasswordField,
        submitButton
      );
    });

    confirmPasswordField.addEventListener("input", function (event) {
      handleInputEvent(
        event,
        editPasswordField,
        confirmPasswordField,
        submitButton
      );
    });

    confirmPasswordField.addEventListener("blur", function () {
      const confirmPassword = confirmPasswordField.value;
      const password = editPasswordField.value;

      if (confirmPassword !== password) {
        submitButton.disabled = true;
        document.getElementById("password-warning").style.display = "block";
      }
    });
  }

  if (passwordResetField && passwordResetConfirmField) {
    passwordResetField.addEventListener("input", function (event) {
      handleInputEvent(
        event,
        passwordResetField,
        passwordResetConfirmField,
        resetSubmitButton
      );
    });

    passwordResetConfirmField.addEventListener("input", function (event) {
      handleInputEvent(
        event,
        passwordResetField,
        passwordResetConfirmField,
        resetSubmitButton
      );
    });

    passwordResetConfirmField.addEventListener("blur", function () {
      const confirmPassword = passwordResetConfirmField.value;
      const password = passwordResetField.value;

      if (confirmPassword !== password) {
        resetSubmitButton.disabled = true;
        document.getElementById("password-warning").style.display = "block";
      }
    });
  }

  // New Event Listeners for Customer Password Fields
  if (customerPasswordField && customerPasswordConfirmField) {
    customerPasswordField.addEventListener("input", function (event) {
      handleInputEvent(
        event,
        customerPasswordField,
        customerPasswordConfirmField,
        activateSubmitButton
      );
    });

    customerPasswordConfirmField.addEventListener("input", function (event) {
      handleInputEvent(
        event,
        customerPasswordField,
        customerPasswordConfirmField,
        activateSubmitButton
      );
    });

    customerPasswordConfirmField.addEventListener("blur", function () {
      const confirmPassword = customerPasswordConfirmField.value;
      const password = customerPasswordField.value;

      if (confirmPassword !== password) {
        activateSubmitButton.disabled = true;
        document.getElementById("password-warning").style.display = "block";
      }
    });
  }

  // Disable submit buttons by default
  if (submitButton) submitButton.disabled = true;
  if (resetSubmitButton) resetSubmitButton.disabled = true;
  if (activateSubmitButton) activateSubmitButton.disabled = true;
})();
